export const background = {
  default: '#fafafa',
  subtle: '#f5f5f5',
}
export const surface = {
  default: '#ffffff',
  raised: '#ffffff',
  sunken: '#f5f5f5',
}
export const text = {
  default: '#0e1113',
  muted: '#495054',
  subtle: '#888f92',
  inverse: '#ffffff',
  link: '#002664',
}
export const border = {
  default: '#dcdfe0',
  subtle: '#ebebeb',
  strong: '#888f92',
}
export const action = {
  default: '#002664',
  hover: '#001037',
  subtle: '#f0fbff',
}
export const success = {
  surface: '#eff9ed',
  text: '#005a02',
  border: '#8fc78a',
  solid: '#008a07',
}
export const warning = {
  surface: '#fff3ed',
  text: '#882f03',
  border: '#eea88a',
  solid: '#c95000',
}
export const danger = {
  surface: '#fff0ef',
  text: '#7c061f',
  border: '#ea9294',
  solid: '#b81237',
}
export const info = {
  surface: '#e9eef7',
  text: '#193366',
  border: '#8098c2',
  solid: '#2e5299',
}
